export const SET_BOOKING_LOADING = 'BOOKING_LOADING';
export const BOOKING_UPDATE = 'BOOKING_UPDATE';
export const FETCH_EXTRAS_SUCCESS = 'EXTRAS_SUCCESS';
export const SET_FLEX_EXTRAS = 'SET_FLEX_EXTRAS'
export const SET_FLEX_EXTRA_SELECTED = 'SET_FLEX_EXTRA_SELECTED'
export const SELECT_BOOKING_EXTRA = 'SELECT_BOOKING_EXTRA';
export const SET_BOOKING_EXTRA_QUANTITY = 'SET_BOOKING_EXTRA_QUANTITY';
export const SET_BOOKING_PASSENGERS = 'SET_BOOKING_PASSENGERS';
export const SET_BOOKING_DISCOUNT_CODE = 'SET_BOOKING_DISCOUNT_CODE';
export const SET_BOOKING_RESERVATION = 'SET_BOOKING_RESERVATION';
export const SET_BOOKING_NEWSLETTER = 'SET_BOOKING_NEWSLETTER';
export const SET_TERMS = 'SET_TERMS';
export const RESET_BOOKING_STATE = 'RESET_BOOKING_STATE';
export const SET_DOCUMENT_NEED_MUTATION = 'SET_DOCUMENT_NEED_MUTATION';
